import { GLTFExporter } from 'three/examples/jsm/exporters/GLTFExporter.js';
import { Logger } from '../utils/logger';

export { exportScene };

function exportScene(modelViewer, options) {
    new GLTFExporter().parse(
        modelViewer.scene,
        (gltf) => _saveScene(gltf),
        options
    );
}

function _saveScene(scene) {
    if (scene instanceof ArrayBuffer) {
        _saveArrayBuffer(scene, 'scene.glb');
        return;
    }
    const output = JSON.stringify(scene, null, 2);
    Logger.debug(output);
    _saveString(output, 'scene.gltf');
}

function _save(blob, filename) {
    const link = document.createElement('a');
    document.body.append(link);
    link.href = URL.createObjectURL(blob);
    link.download = filename;
    link.click();
    link.remove();
}

function _saveString(text, filename) {
    _save(new Blob([text], { type: 'text/plain' }), filename);
}

function _saveArrayBuffer(buffer, filename) {
    _save(new Blob([buffer], { type: 'application/octet-stream' }), filename);
}
